const translations = {
  "en": {
    "Add Assets": "Add Assets"
  },
  "zh-tw": {
    "Add Assets": "新增資產"
  }
};

export default translations;
